/**
 * Created by dorin on 6/22/17.
 */
import React from 'react';
import { connect } from 'react-redux';
import NavButtons from '../NavButtons';
import { Form, FormGroup, FormControl } from 'react-bootstrap';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';

class ForgotPassword extends React.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      email: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    const { status, error, dispatch } = nextProps;

    if (status === actionTypes.AUTH_FORGOT_ERROR) {
      if (error) {
        const errors = Object.values(error);
        errors.forEach((e) => dispatch(actions.alert('error', e[0])));
      } else {
        dispatch(
          actions.alert(
            'error',
            'Oops! Something went wrong. Please try to reset your password again. If this error persists, please contact us.'
          )
        );
      }
    } else if (status === actionTypes.AUTH_FORGOT_SUCCESS) {
      dispatch(
        actions.alert(
          'success',
          'Please check your email for further instructions to reset your password.'
        )
      );
      this.props.router.push('/login');
    }
  }

  send(e) {
    e.preventDefault();

    const { dispatch } = this.props;
    const { email } = this.state;

    dispatch(actions.hideAlert());

    if (email !== '') {
      dispatch(actions.forgotPassword(email.toLowerCase()));
    }
  }

  handleChange = (e) => {
    this.setState({ email: e.target.value });
  };

  render() {
    const { status } = this.props;
    const { email } = this.state;

    return (
      <div className="forgot-password">
        <h3 className="title">Reset your Password</h3>
        <p>
          If an account is associated with your email address, a link to reset
          your password will be sent to that address.
        </p>
        <hr className="transparent" />

        <Form onSubmit={(e) => this.send(e)}>
          <FormGroup>
            <FormControl
              type="email"
              placeholder="Email"
              value={email}
              onChange={this.handleChange}
              autoFocus
              required
            />
          </FormGroup>
          <FormGroup className="actions mt-30px">
            <div>
              <NavButtons
                direction="back"
                prev={() => this.props.router.push('/login')}
              />
            </div>
            <div>
              <button
                type="submit"
                disabled={status === actionTypes.AUTH_FORGOT_REQUEST}
              >
                {status === actionTypes.AUTH_FORGOT_REQUEST && (
                  <i className="fa fa-refresh fa-spin fa-fw mr-5px"></i>
                )}
                reset my password
              </button>
            </div>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  status: state.auth.status,
  error: state.auth.error,
});

export default connect(mapStateToProps)(ForgotPassword);



// WEBPACK FOOTER //
// src/components/Auth/ForgotPassword.jsx